import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Tabs from "../../components/common/Tabs";

const tabs = [
  {
    link: "/maintenance/work-orders",
    title: "Work Orders",
  },
  {
    link: "/maintenance/recurring-work-orders",
    title: "Recurring Work Orders",
  },
  {
    link: "/maintenance/inspections",
    title: "Inspections",
  },
  {
    link: "/maintenance/unit-turns",
    title: "Unit Turns",
  },
];

function Maintenance() {
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} keepFirstLinkActive={true}/>
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default Maintenance;
